export type MobileMenuButtonItemProps = {
  title?: string;
  icon?: string;
  onClick?: () => void | Promise<void>;
  isActive?: boolean;
  isDropdown?: boolean;
  disabled?: boolean;
  testID?: string;
};

export function MobileMenuButtonItem({
  title,
  icon,
  onClick,
  isActive = false,
  isDropdown = false,
  disabled = false,
  testID,
}: MobileMenuButtonItemProps) {
  const effectiveCssClass = 'd-flex' + (isActive ? ' active' : '') + (disabled ? ' disabled' : '');

  const dropdownAttributes = isDropdown
    ? ({ 'data-bs-toggle': 'dropdown', 'data-bs-offset': '0,0', 'aria-expanded': false } as const)
    : {};

  return (
    <button
      type="button"
      className={`mobile-menu-button-item border-0 bg-transparent text-white ${effectiveCssClass}`}
      onClick={() => void onClick?.()}
      disabled={disabled}
      data-testid={testID}
      {...dropdownAttributes}
    >
      {icon != null && (
        <div>
          <i className={`${icon} fa-xl`}></i>
        </div>
      )}
      {title != null && <span className="small">{title}</span>}
    </button>
  );
}
